export default __webpack_public_path__ + "static/media/LOST.e99a8c7e.png";